var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"nostroke","fillRule":"evenodd","clipRule":"evenodd","d":"M18.4535 6.49989L13.3195 1.73268L14.6805 0.26709L21.6805 6.76709L22.4696 7.49988L21.6805 8.23268L14.6805 14.7327L13.3195 13.2671L18.4535 8.49989L0 8.49988V6.49988L18.4535 6.49989Z","fill":"#1A192B"}));
}

ArrowRight.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
